module.exports = __webpack_public_path__ + "static/LogoFooter-4c1f1acbfd095796e76a28b557cbf76e.png";